import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ProductDescription from './ProductDescription';
import ShipmentTypeDetails from './ShipmentTypeDetails';
import BoxList from './BoxList';
import TotalValues from './TotalValue';
import CreateShipmentContext from '../../../context/CreateShipment';
import { createShipmentContextType } from '../../../types/shipment';
import Actions from '../Actions';
import { getRates, setCreateShipmentCSP } from '../../../store/reducers/GetRates';
import { useDispatch, useSelector } from 'react-redux';
import { SHIPMENT_TYPES } from '../../GetRatesV2/Constant';
import { AddressType } from '../../../store/reducers/GetRates/Type';
import { AppDispatch, RootStateType } from '../../../store';
import NoCSPFound from '../../GetRatesV2/CSPList/NoCSPFound/NoCSPFound';
import ViewAction from '../../ViewSingleShipment/ViewAction';

// let postObj = {
//   destination: { city: 'Mumbai', state: 'Maharashtra', country: 'India', pincode: '400008' },
//   source: { city: 'Mumbai', state: 'Maharashtra', country: 'India', pincode: '400001' },
//   shipmentType: 'parcel',
//   userId: '63bd4bf3abcd13bf437829ba',
//   weight: '200',
//   package: {
//     box: [
//       { weight: '0', length: 0, width: 0, height: 0 },
//       { weight: '0', length: 0, width: 0, height: 0 },
//     ],
//     unitOfMeasurement: 'kg',
//   },
//   document: false,
// };

function getAddressObj({ pincode, city, country, state }: AddressType) {
  return { city, state, country, pincode };
}

const getDutyChargeType = (dutyCharge: any): string => {
  if (!dutyCharge) return '';
  if (typeof dutyCharge === 'string') return dutyCharge;
  if (typeof dutyCharge === 'object' && typeof dutyCharge.type === 'string') return dutyCharge.type;
  return '';
};

function ShipmentDetails({
  removeShipmentInfo,
  showViewMoreAction,
  isShipmentDetailsWriteAllowed,
}: {
  removeShipmentInfo?: boolean;
  showViewMoreAction?: boolean;
  isShipmentDetailsWriteAllowed?: boolean;
}) {
  const [viewMore, setViewMore] = useState<boolean>(true);

  const dispatch = useDispatch<AppDispatch>();
  const {
    activeStep,
    setActiveStep,
    setShowRates,
    chargeableWeight,
    boxes,
    setSelectedBox,
    setSelectedProduct,
    consignee,
    shipper,
    totalShipmentValue: value,
    shipmentType,
    boxValidation,
    userId,
    pickupType: { selectedWearhouseAddress },
    pickupType,
    packageData,
    setDutyChargeError,
  } = React.useContext(CreateShipmentContext) as createShipmentContextType;

  const rates = useSelector((state: RootStateType) => state.getRates);
  const { chareableWeight = { maxChargeableWt: 0 } } = useSelector((state: RootStateType) => state.getRates);
  const { shipmentById } = useSelector((state: RootStateType) => state.adminShipment);
  const countriesNameObj = useSelector((state: RootStateType) => state.global.countriesNameObj) || {};
  const countries = useSelector((state: RootStateType) => state.global.countries) || [];

  const organizationData = useSelector((state: RootStateType) => state.orgSetup.organizationPublicData);
  const { name = '', _country } = organizationData || {};

  const orgCountryName = _country?.name?.trim() || '';

  const getCountryName = (field: any): string => {
    if (!field) return '';
    if (typeof field === 'string') return field.trim();
    if (typeof field === 'object') {
      if (typeof field.country === 'string') return field.country.trim();
      if (field.country && typeof field.country === 'object' && typeof field.country.name === 'string') {
        return field.country.name.trim();
      }
    }
    return '';
  };

  const shipperCountry = getCountryName(shipper);
  const consigneeCountry = getCountryName(consignee);

  let checkCountries: string[] = [];
  if (shipperCountry || consigneeCountry) {
    checkCountries = [shipperCountry, consigneeCountry].filter(Boolean);
  } else {
    checkCountries = [getCountryName(shipmentById?._shipperId), getCountryName(shipmentById?._consigneeId)].filter(
      Boolean,
    );
  }

  const isShipmentExport = orgCountryName
    ? checkCountries.some(c => c.toLowerCase() !== orgCountryName.toLowerCase())
    : false;

  console.log('chargeableWeight:', chargeableWeight);
  //add product button removed
  // function handleAddNewProduct() {
  //   // const productsTemp = [...selectedBox.products];
  //   // const boxesTemp = [...boxes];
  //   // productsTemp.push({ ...defaultProductState });
  //   setSelectedProduct({ ...defaultProductState, id: `${selectedBox?.products?.length}` });
  //   // setSelectedBox({ ...selectedBox, products: [...productsTemp] });
  //   // setBoxes([...boxesTemp]);
  // }

  useEffect(() => {
    if (rates.redirectToCreateShipmentCSP) {
      setActiveStep(activeStep + 1);
      dispatch(setCreateShipmentCSP(false));
    }
  }, [rates.redirectToCreateShipmentCSP]);

  function handleGetRates() {
    if (!getDutyChargeType(shipmentType.dutyCharge)) {
      setDutyChargeError('Duty Charge is required.');
      return;
    }

    if (isShipmentExport) {
      // Find the first product that is missing HSN Code
      let missingProduct: any = null;
      let missingBox: any = null;
      let missingProductIndex = -1;

      for (const box of boxes) {
        if (box.products) {
          const idx = box.products.findIndex(p => !p.HSNCode?.trim());
          if (idx !== -1) {
            missingProduct = box.products[idx];
            missingBox = box;
            missingProductIndex = idx;
            break;
          }
        }
      }

      if (missingProduct) {
        // 1. Select the box
        setSelectedBox(missingBox);
        // 2. Select the product to load it into the form for editing and show validation
        setSelectedProduct({
          ...missingProduct,
          id: missingProductIndex.toString(),
          isUpdate: true,
        });
        return; // Do not call the API
      }

      const getCountryCode = (countryName: string): string => {
        if (!countryName) return '';
        const trimmedName = countryName.trim();
        if (countriesNameObj[trimmedName]?.countryCode) {
          return countriesNameObj[trimmedName].countryCode;
        }
        const keys = Object.keys(countriesNameObj);
        const matchedKey = keys.find(k => k.toLowerCase() === trimmedName.toLowerCase());
        if (matchedKey && countriesNameObj[matchedKey]?.countryCode) {
          return countriesNameObj[matchedKey].countryCode;
        }
        const foundCountry = countries.find(c => {
          if (c.name?.toLowerCase() === trimmedName.toLowerCase()) return true;
          if (c.alternateNames?.some(alt => alt.toLowerCase() === trimmedName.toLowerCase())) return true;
          return false;
        });
        return foundCountry?.countryCode || '';
      };

      const sourceAddr = selectedWearhouseAddress?.label ? selectedWearhouseAddress : shipper;
      const destAddr = consignee;

      const internationalPayload = {
        destination: {
          city: destAddr.city || '',
          state: destAddr.state || '',
          country: destAddr.country || '',
          countryCode: getCountryCode(destAddr.country),
          pincode: destAddr.pincode || '',
        },
        source: {
          city: sourceAddr.city || '',
          state: sourceAddr.state || '',
          country: sourceAddr.country || '',
          countryCode: getCountryCode(sourceAddr.country),
          pincode: sourceAddr.pincode || '',
        },
        shipmentType: shipmentType.type,
        userId,
        weight: chareableWeight?.maxChargeableWt || 0,
        value,
        package: {
          box: boxes.flatMap(box => {
            const boxWeight = box.weight !== undefined && box.weight !== null ? box.weight.toString() : '0';
            const boxLength = box.length !== undefined && box.length !== null ? box.length.toString() : '0';
            const boxWidth = box.width !== undefined && box.width !== null ? box.width.toString() : '0';
            const boxHeight = box.height !== undefined && box.height !== null ? box.height.toString() : '0';

            return (box.products || []).map(product => ({
              hsnCode: product.HSNCode || '',
              qty: product.quantity || '',
              value: product.unitValue ?? 0,
              description: product.description || '',
              weight: boxWeight,
              length: boxLength,
              width: boxWidth,
              height: boxHeight,
            }));
          }),
          unitOfMeasurement: shipmentType.unit,
        },
        document: shipmentType.type === SHIPMENT_TYPES[1].value,
        insurance: packageData.insurance,
        packaging: packageData.packaging,
        currency: shipmentType.currency,
        dropOff: pickupType.type === 'dropOff' ? true : false,
        organizationName: name === 'Cargo Solutions Network',
        rateFor: 'create-shipment' as const,
        dutyCharge: getDutyChargeType(shipmentType.dutyCharge),
      };

      dispatch(getRates([internationalPayload, false]));
    } else {
      // Domestic flow: keep completely unchanged
      const obj = {
        destination: { ...getAddressObj(consignee) },
        source: { ...getAddressObj(selectedWearhouseAddress?.label ? selectedWearhouseAddress : shipper) },
        shipmentType: shipmentType.type,
        userId,
        weight: chareableWeight?.maxChargeableWt || 0,
        value,
        package: {
          box: boxes.map(box => ({
            weight: box.weight.toString(),
            length: box.length,
            width: box.width,
            height: box.height,
          })),
          unitOfMeasurement: shipmentType.unit,
        },
        document: shipmentType.type === SHIPMENT_TYPES[1].value,
        insurance: packageData.insurance,
        packaging: packageData.packaging,
        dropOff: pickupType.type === 'dropOff' ? true : false,
        dutyCharge: getDutyChargeType(shipmentType.dutyCharge),
      };
      dispatch(
        getRates([{ ...obj, organizationName: name === 'Cargo Solutions Network', rateFor: 'create-shipment' }, false]),
      );
    }
  }

  return (
    <>
      <Grid container>
        {!removeShipmentInfo && <ShipmentTypeDetails />}
        <Grid container item>
          <TotalValues />
        </Grid>
        {showViewMoreAction && (
          <Grid container justifyContent="flex-end">
            <ViewAction setViewMore={setViewMore} viewMore={viewMore} />
          </Grid>
        )}
        {(viewMore || !showViewMoreAction) && (
          <Grid container className="my-3" spacing={2}>
            <Grid item lg={4} xl={3} md={4} sm={12} xs={12}>
              <BoxList writeAccess={isShipmentDetailsWriteAllowed} />
            </Grid>
            <Grid item lg={8} xl={9} md={8} sm={12} xs={12}>
              <ProductDescription writeAccess={isShipmentDetailsWriteAllowed} />
              {/* <DashedBtn classes="w-full" label={'Add a Product'} onClick={handleAddNewProduct} /> */}
            </Grid>
          </Grid>
        )}
      </Grid>
      {!removeShipmentInfo && <Actions onNext={handleGetRates} disableNext={!boxValidation} />}
      <NoCSPFound setShowRates={setShowRates} />
    </>
  );
}

export default ShipmentDetails;
